'use strict';

module.exports = require('./Table');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.0.5@rc-table/lib/index.js
 ** module id = 528
 ** module chunks = 0
 **/